if (!customElements.get('header-v2')) {
  class HeaderV2 extends HTMLElement {
    constructor() {
      super();
      this.onScroll = this.onScroll.bind(this);
      this.onTabAction = this.onTabAction.bind(this);
      this.lastScrollTop = 0;
    }

    connectedCallback() {
      if (window.location.pathname.toLowerCase().includes('clinic') || window.location.href.toLowerCase().includes('clinic')) {
        this.classList.add('header-v2--clinic');
      }

      if (this.hasAttribute('sticky')) {
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }

      this.addEventListener('mouseover', this.onTabAction);
      this.addEventListener('mouseenter', this.onTabAction);
      this.addEventListener('click', this.onTabAction);

      this.initMegaMenuHover();
      this.initSearch();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.removeEventListener('mouseover', this.onTabAction);
      this.removeEventListener('mouseenter', this.onTabAction);
      this.removeEventListener('click', this.onTabAction);
      if (this.cleanupSearch) {
        this.cleanupSearch();
      }
    }

    initMegaMenuHover() {
      const disclosures = this.querySelectorAll('details.header-v2__mega-disclosure');

      disclosures.forEach(details => {
        const summary = details.querySelector('summary');

        // Instant 0ms Open on Mouseover
        details.addEventListener('mouseover', (e) => {
          // Close all other disclosures
          disclosures.forEach(other => {
            if (other !== details) {
              other.removeAttribute('open');
            }
          });
          details.setAttribute('open', '');
        });

        // Instant 0ms Close on Mouseout
        details.addEventListener('mouseout', (e) => {
          if (!details.contains(e.relatedTarget)) {
            details.removeAttribute('open');
          }
        });

        // Handle navigation link clicks if data-url is present
        if (summary) {
          summary.addEventListener('click', (e) => {
            const dataUrl = summary.getAttribute('data-url');
            if (dataUrl && dataUrl !== 'javascript:void(0);') {
              window.location.href = dataUrl;
            }
          });
        }
      });
    }

    onTabAction(event) {
      const tab = event.target.closest('.header-v2__mega-tab');
      if (!tab) return;

      const tabId = tab.getAttribute('data-tab-id');
      if (!tabId) return;

      const parentMega = tab.closest('.header-v2__mega-menu');
      if (!parentMega) return;

      const tabs = parentMega.querySelectorAll('.header-v2__mega-tab');
      tabs.forEach(t => t.classList.remove('header-v2__mega-tab--active'));
      tab.classList.add('header-v2__mega-tab--active');

      const panels = parentMega.querySelectorAll('.header-v2__mega-panel');
      panels.forEach(p => p.classList.remove('header-v2__mega-panel--active'));

      const targetPanel = parentMega.querySelector(`#${tabId}`);
      if (targetPanel) {
        targetPanel.classList.add('header-v2__mega-panel--active');
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop > 50) {
        this.classList.add('header-v2--scrolled');
      } else {
        this.classList.remove('header-v2--scrolled');
      }

      this.lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    initSearch() {
      const toggleBtn = this.querySelector('#HeaderSearchLiquidToggle') || document.getElementById('HeaderSearchLiquidToggle');
      const wrapper = this.querySelector('#HeaderSearchLiquidWrapper') || document.getElementById('HeaderSearchLiquidWrapper');
      const content = this.querySelector('#HeaderSearchLiquidContent') || document.getElementById('HeaderSearchLiquidContent');
      const closeBtn = this.querySelector('#HeaderSearchLiquidClose') || document.getElementById('HeaderSearchLiquidClose');

      if (!toggleBtn || !wrapper) return;

      const openSearch = (e) => {
        if (e) e.preventDefault();
        wrapper.classList.add('is-expanded');
        this.classList.add('search-is-active');

        const overlay = document.getElementById('search-container-overlay');
        if (overlay) {
          overlay.classList.add('active');
        }

        // Focus the correct input based on screen size
        const activeSearchInput = window.innerWidth <= 768
          ? document.getElementById('st-search-mobile')
          : document.getElementById('st-search');

        if (activeSearchInput) {
          activeSearchInput.focus({ preventScroll: true });
        }
      };

      const closeSearch = (e) => {
        if (e && e.preventDefault) e.preventDefault();
        wrapper.classList.remove('is-expanded');
        this.classList.remove('search-is-active');
        document.body.classList.remove('search-autocomplete-visible');

        const overlay = document.getElementById('search-container-overlay');
        if (overlay) {
          overlay.classList.remove('active');
        }

        // Blur inputs to dismiss keyboard and prevent scroll jumps
        const desktopInput = document.getElementById('st-search');
        const mobileInput = document.getElementById('st-search-mobile');
        if (desktopInput) desktopInput.blur();
        if (mobileInput) mobileInput.blur();
      };

      toggleBtn.addEventListener('click', openSearch);

      const onTransitionEnd = (e) => {
        if (e.propertyName === 'width' && wrapper.classList.contains('is-expanded')) {
          document.body.classList.add('search-autocomplete-visible');
        }
      };
      wrapper.addEventListener('transitionend', onTransitionEnd);

      if (closeBtn) {
        closeBtn.addEventListener('click', closeSearch);
      }

      const overlayEl = document.getElementById('search-container-overlay');
      if (overlayEl) {
        overlayEl.addEventListener('click', closeSearch);
      }

      // Handle document clicks (Click outside to close, OR click on dynamic mobile back arrow)
      const onDocumentClick = (e) => {
        // 1. Check if clicked the app-injected mobile close button
        if (e.target.closest('.st-mobile-back-arrow')) {
          closeSearch(e);
          return;
        }

        // 2. Click outside logic
        const autocomplete = document.getElementById('st-autocomplete-container');
        const isClickInsideAutocomplete = autocomplete && autocomplete.contains(e.target);
        const isClickInsideWrapper = wrapper.contains(e.target);
        const isClickOnToggle = toggleBtn.contains(e.target);
        const currentOverlay = document.getElementById('search-container-overlay');
        const isClickOnOverlay = currentOverlay && currentOverlay.contains(e.target);

        if (
          wrapper.classList.contains('is-expanded') &&
          !isClickInsideWrapper &&
          !isClickOnToggle &&
          !isClickInsideAutocomplete &&
          !isClickOnOverlay
        ) {
          closeSearch();
        }
      };

      const onKeyDown = (e) => {
        if (e.key === 'Escape' && wrapper.classList.contains('is-expanded')) {
          closeSearch();
        }
      };

      document.addEventListener('click', onDocumentClick);
      document.addEventListener('keydown', onKeyDown);

      this.cleanupSearch = () => {
        toggleBtn.removeEventListener('click', openSearch);
        wrapper.removeEventListener('transitionend', onTransitionEnd);
        if (closeBtn) closeBtn.removeEventListener('click', closeSearch);
        const currentOverlay = document.getElementById('search-container-overlay');
        if (currentOverlay) currentOverlay.removeEventListener('click', closeSearch);
        document.removeEventListener('click', onDocumentClick);
        document.removeEventListener('keydown', onKeyDown);
      };
    }
  }

  customElements.define('header-v2', HeaderV2);
}
